export enum GlobalSearchConstants {
  GET_ALL_GLOBAL_SEARCH_DATA = "GET_ALL_GLOBAL_SEARCH_DATA",
  GET_ALL_GLOBAL_SEARCH_DATA_SUCCESS = "GET_ALL_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_ALL_GLOBAL_SEARCH_DATA_FAIL = "GET_ALL_GLOBAL_SEARCH_DATA_FAIL",

  GET_INVOICE_REF_GLOBAL_SEARCH_DATA = "GET_INVOICE_REF_GLOBAL_SEARCH_DATA",
  GET_INVOICE_REF_GLOBAL_SEARCH_DATA_SUCCESS = "GET_INVOICE_REF_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_INVOICE_REF_GLOBAL_SEARCH_DATA_FAIL = "GET_INVOICE_REF_GLOBAL_SEARCH_DATA_FAIL",

  GET_INVOICE_GLOBAL_SEARCH_DATA = "GET_INVOICE_GLOBAL_SEARCH_DATA",
  GET_INVOICE_GLOBAL_SEARCH_DATA_SUCCESS = "GET_INVOICE_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_INVOICE_GLOBAL_SEARCH_DATA_FAIL = "GET_INVOICE_GLOBAL_SEARCH_DATA_FAIL",

  GET_CASE_GLOBAL_SEARCH_DATA = "GET_CASE_GLOBAL_SEARCH_DATA",
  GET_CASE_GLOBAL_SEARCH_DATA_SUCCESS = "GET_CASE_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_CASE_GLOBAL_SEARCH_DATA_FAIL = "GET_CASE_GLOBAL_SEARCH_DATA_FAIL",

  GET_DEBTOR_GLOBAL_SEARCH_DATA = "GET_DEBTOR_GLOBAL_SEARCH_DATA",
  GET_DEBTOR_GLOBAL_SEARCH_DATA_SUCCESS = "GET_DEBTOR_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_DEBTOR_GLOBAL_SEARCH_DATA_FAIL = "GET_DEBTOR_GLOBAL_SEARCH_DATA_FAIL",

  GET_CREDITOR_GLOBAL_SEARCH_DATA = "GET_CREDITOR_GLOBAL_SEARCH_DATA",
  GET_CREDITOR_GLOBAL_SEARCH_DATA_SUCCESS = "GET_CREDITOR_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_CREDITOR_GLOBAL_SEARCH_DATA_FAIL = "GET_CREDITOR_GLOBAL_SEARCH_DATA_FAIL",

  GET_GLOBAL_SEARCH_HISTORY = "GET_GLOBAL_SEARCH_HISTORY",
  SAVE_GLOBAL_SEARCH_HISTORY = "SAVE_GLOBAL_SEARCH_HISTORY",
  GET_GLOBAL_SEARCH_HISTORY_SUCCESS = "GET_GLOBAL_SEARCH_HISTORY_SUCCESS",
  GET_GLOBAL_SEARCH_HISTORY_FAIL = "GET_GLOBAL_SEARCH_HISTORY_FAIL",

  TOGGLE_GLOBAL_DEBTOR_AR = "TOGGLE_GLOBAL_DEBTOR_AR",
  TOGGLE_GLOBAL_CREDITOR_GROUP = "TOGGLE_GLOBAL_CREDITOR_GROUP",

  GLOBAL_BROWSER_BACK_NAVIGATION = "GLOBAL_BROWSER_BACK_NAVIGATION",

  UPDATE_VIEWED_GLOBAL_LIST = "UPDATE_VIEWED_GLOBAL_LIST",

  GET_ARCHIVE_GLOBAL_SEARCH_DATA = "GET_ARCHIVE_GLOBAL_SEARCH_DATA",
  GET_ARCHIVE_GLOBAL_SEARCH_DATA_SUCCESS = "GET_ARCHIVE_GLOBAL_SEARCH_DATA_SUCCESS",
  GET_ARCHIVE_GLOBAL_SEARCH_DATA_FAIL = "GET_ARCHIVE_GLOBAL_SEARCH_DATA_FAIL",

  GET_ARCHIVE_GLOBAL_CASE_DETAILS = "GET_ARCHIVE_GLOBAL_CASE_DETAILS",
  GET_ARCHIVE_GLOBAL_CASE_DETAILS_SUCCESS = "GET_ARCHIVE_GLOBAL_CASE_DETAILS_SUCCESS",
  GET_ARCHIVE_GLOBAL_CASE_DETAILS_FAIL = "GET_ARCHIVE_GLOBAL_CASE_DETAILS_FAIL",

  GET_COMPANY_CONFIG = "GET_COMPANY_CONFIG",
  GET_COMPANY_CONFIG_SUCCESS = "GET_COMPANY_CONFIG_SUCCESS",
  GET_COMPANY_CONFIG_FAIL = "GET_COMPANY_CONFIG_FAIL",
}
